/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JobMatchFilters } from './JobMatchFilters';
import {
    JobMatchFiltersFromJSON,
    JobMatchFiltersFromJSONTyped,
    JobMatchFiltersToJSON,
} from './JobMatchFilters';
import type { JobMatchGeoSettings } from './JobMatchGeoSettings';
import {
    JobMatchGeoSettingsFromJSON,
    JobMatchGeoSettingsFromJSONTyped,
    JobMatchGeoSettingsToJSON,
} from './JobMatchGeoSettings';
import type { JobMatchNotificationSettings } from './JobMatchNotificationSettings';
import {
    JobMatchNotificationSettingsFromJSON,
    JobMatchNotificationSettingsFromJSONTyped,
    JobMatchNotificationSettingsToJSON,
} from './JobMatchNotificationSettings';
import type { JobMatchOccupation } from './JobMatchOccupation';
import {
    JobMatchOccupationFromJSON,
    JobMatchOccupationFromJSONTyped,
    JobMatchOccupationToJSON,
} from './JobMatchOccupation';

/**
 * 
 * @export
 * @interface JobMatchProfile
 */
export interface JobMatchProfile {
    /**
     * 
     * @type {number}
     * @memberof JobMatchProfile
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof JobMatchProfile
     */
    candidateId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobMatchProfile
     */
    currentJobDescription?: string;
    /**
     * 
     * @type {Date}
     * @memberof JobMatchProfile
     */
    jobMatchPageLastVisited?: Date;
    /**
     * 
     * @type {JobMatchGeoSettings}
     * @memberof JobMatchProfile
     */
    geoSettings?: JobMatchGeoSettings;
    /**
     * 
     * @type {JobMatchNotificationSettings}
     * @memberof JobMatchProfile
     */
    notificationSettings?: JobMatchNotificationSettings;
    /**
     * 
     * @type {Array<JobMatchOccupation>}
     * @memberof JobMatchProfile
     */
    selectedOccupations?: Array<JobMatchOccupation>;
    /**
     * 
     * @type {JobMatchFilters}
     * @memberof JobMatchProfile
     */
    profileFilters?: JobMatchFilters;
}

/**
 * Check if a given object implements the JobMatchProfile interface.
 */
export function instanceOfJobMatchProfile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JobMatchProfileFromJSON(json: any): JobMatchProfile {
    return JobMatchProfileFromJSONTyped(json, false);
}

export function JobMatchProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobMatchProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'candidateId': !exists(json, 'CandidateId') ? undefined : json['CandidateId'],
        'currentJobDescription': !exists(json, 'CurrentJobDescription') ? undefined : json['CurrentJobDescription'],
        'jobMatchPageLastVisited': !exists(json, 'JobMatchPageLastVisited') ? undefined : (new Date(json['JobMatchPageLastVisited'])),
        'geoSettings': !exists(json, 'GeoSettings') ? undefined : JobMatchGeoSettingsFromJSON(json['GeoSettings']),
        'notificationSettings': !exists(json, 'NotificationSettings') ? undefined : JobMatchNotificationSettingsFromJSON(json['NotificationSettings']),
        'selectedOccupations': !exists(json, 'SelectedOccupations') ? undefined : ((json['SelectedOccupations'] as Array<any>).map(JobMatchOccupationFromJSON)),
        'profileFilters': !exists(json, 'ProfileFilters') ? undefined : JobMatchFiltersFromJSON(json['ProfileFilters']),
    };
}

export function JobMatchProfileToJSON(value?: JobMatchProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'CandidateId': value.candidateId,
        'CurrentJobDescription': value.currentJobDescription,
        'JobMatchPageLastVisited': value.jobMatchPageLastVisited === undefined ? undefined : (value.jobMatchPageLastVisited.toISOString()),
        'GeoSettings': JobMatchGeoSettingsToJSON(value.geoSettings),
        'NotificationSettings': JobMatchNotificationSettingsToJSON(value.notificationSettings),
        'SelectedOccupations': value.selectedOccupations === undefined ? undefined : ((value.selectedOccupations as Array<any>).map(JobMatchOccupationToJSON)),
        'ProfileFilters': JobMatchFiltersToJSON(value.profileFilters),
    };
}

